export default "__VITE_ASSET__CFpR_Kmv__"